var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasActiveComponent)?_c('div',[_c('portal-collapse',{attrs:{"title":"Employment Timesheet Grants"}},[_c('employment-timesheet-grants',{attrs:{"employment":_vm.employment}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }